import { useEffect, useState } from 'react';
import { useLayers } from './LayerProvider';
import { LayerSurface } from './LayerSurface';
import type { LayerDelivery } from './types';

/**
 * Pojmenované místo ve stránce pro weblayery `banner`/`inline`/`recommendation`.
 * Výloha jím osadí pevná místa (pod carousel, pod popis produktu, nad souhrn
 * košíku, nad výpis kategorie). Neznámý slot = nic se nevykreslí.
 *
 * Slot si zvolenou vrstvu „zamkne": jakmile ji vykreslí, zaznamená zobrazení
 * a drží ji, dokud ji zákazník nezavře — jinak by ji záznam zobrazení
 * (frekvenční cap) vzápětí odfiltroval a vrstva by zmizela.
 */
export function LayerSlot({ name }: { name: string }) {
  const { candidatesForSlot, markSlotShown, close, interact, submitted } = useLayers();
  const [active, setActive] = useState<LayerDelivery | null>(null);

  const candidates = candidatesForSlot(name);
  const firstId = candidates[0]?.id ?? null;

  useEffect(() => {
    if (active !== null) return;
    const next = candidates[0];
    if (next !== undefined) {
      markSlotShown(next);
      setActive(next);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstId, active]);

  if (active === null) return null;

  return (
    <div className="layer-slot" data-slot={name}>
      <LayerSurface
        layer={active}
        onClose={() => {
          close(active);
          setActive(null);
        }}
        onInteract={(kind) => interact(active, kind)}
        onSubmitted={() => submitted(active)}
      />
    </div>
  );
}
